<div *ngIf="isPreview"
    class="fixed bottom-4 left-4 z-[2000] rounded bg-black/80 px-3 py-1 text-sm font-semibold text-white pointer-events-none">
    Preview mode
</div>
<ng-container *ngIf="isLoading(); else content">
  <div class="flex items-center justify-center min-h-[300px]">
    <p-progress-spinner ariaLabel="loading" />
  </div>
</ng-container>

<ng-template #content>
  <app-cookies-disabled-banner></app-cookies-disabled-banner>

  <div>
    @if (homePageData() != null) {
    <app-header [id]="id" [shareSocialMediaData]="{type: 'auction', id:id}"></app-header>
    } @else {
    <div class="flex items-center justify-center h-[66px] lg:h-[132px]">
      <p-progress-spinner ariaLabel="loading header" />
    </div>
    }
  </div>



  <p-scrolltop target="window" [threshold]="100" icon="pi pi-chevron-up" class="block md:hidden"
    [buttonProps]="{ severity: 'contrast', raised: true, rounded: true }">
  </p-scrolltop>

  <!-- banner section  -->
  <div
    class="relative h-48 lg:h-[calc(100vh-230px)] flex flex-col justify-center items-center px-3 text-center overflow-hidden">
    <img [src]="imageBanner" aria-label="Auction Hero Image"
      class="absolute inset-0 w-full h-full object-fill md:object-cover" />

    @if (showHeroImageText()
        || showHeroImageSubText()
        || homePageData()?.showThermometer
        || (!isAuthenticated().isAuthenticated
            && (homePageData()?.showHeroSignInButton
                || homePageData()?.showHeroRegisterButton))
        || (isAuthenticated().isAuthenticated
            && (heroButton1() != null
                || heroButton2() != null))) {
       <div class="absolute inset-0 bg-gradient-to-b from-black/40 to-black/20 z-0"></div>
    }
    @if (showHeroImageText()) {
    <h1 class="relative z-10 text-white font-mulish font-bold tracking-normal "
      style="text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);">
      <span class="text-[25px] lg:text-[50px] font-bold" [innerHtml]="heroImageText()"></span>
    </h1>
    }
    @if (showHeroImageSubText()) {
    <h2 class="relative z-10 text-gray-300 font-mulish font-medium uppercase mb-1 lg:mb-0">
      <span class="text-[14px] md:text-lg" [innerHtml]="heroImageSubText()"></span>
    </h2>
    }

    @if (!isAuthenticated().isAuthenticated) {
    <div class="flex gap-5 z-10">
      @if (homePageData()?.showHeroSignInButton) {
      <button (click)="openLoginModal()" class="!bg-[var(--p-primary-500)] !border-[var(--p-primary-500)]
              hover:!bg-[var(--p-primary-600)] hover:!border-[var(--p-primary-600)]
              active:!bg-[var(--p-primary-700)] active:!border-[var(--p-primary-700)] rounded-2xl w-32 h-7 md:h-9 !text-[var(--p-text-color-primary)]">Sign In</button>
      }
      @if (homePageData()?.showHeroRegisterButton) {
      <button (click)="openRegisterModal()"
        class="!bg-[var(--p-primary-500)] !border-[var(--p-primary-500)]
              hover:!bg-[var(--p-primary-600)] hover:!border-[var(--p-primary-600)]
              active:!bg-[var(--p-primary-700)] active:!border-[var(--p-primary-700)] rounded-2xl w-32 h-7 md:h-9 !text-[var(--p-text-color-primary)]">Register</button>
      }
    </div>
    }

    @if (isAuthenticated().isAuthenticated) {
    <div class="flex gap-5 z-10">
      <ng-container [ngTemplateOutlet]="heroButton1()"></ng-container>

      <ng-container [ngTemplateOutlet]="heroButton2()"></ng-container>
    </div>
    }

    @if (homePageData()?.showThermometer) {
    <div id="progress-bar" class="w-full sm:w-[30rem] md:w-[40rem] lg:w-[50rem]  lg:px-3 pt-2 lg:pt-10 flex flex-col">
      <div class="flex justify-between relative z-10 opacity-90">
        <span class="{{titleColor}} text-[14px] lg:text-[28px]">
          <strong style="text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5)">{{ homePageData()?.raised }}</strong>
          <span class="text-[12px] font-semibold" style="text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);"> Raised</span>
        </span>
        <span class="{{titleColor}} text-[14px] lg:text-[28px]">
          <strong>{{ homePageData()?.goal}}</strong>
          <span class="text-[12px] font-semibold" style="text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);"> Goal</span>
        </span>
      </div>
      <p-progressbar [value]="homePageData()?.percentRevenueGoal" [color]="'var(--p-primary-500)'"
        class="custom-progressbar" />
      <div class="hidden lg:flex justify-between  relative z-10 opacity-80">
        <span class="{{titleColor}} text-white text-[12px] font-semibold" style="text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);">
          {{ homePageData()?.percentItemsBidded }} of items with Bids
        </span>
        <span class="{{titleColor}} text-[12px] font-semibold" style="text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);">
          {{ homePageData()?.totalBids}} Bids in Total
        </span>
      </div>
    </div>
    }
  </div>

  <div class="bg-gray-50  lg:border-b border-gray-300 w-full pb-8">
    <div class="container mx-auto px-5 lg:px-10">

      <!-- buttons and search bar section -->

      <div id="controls" class="h-auto">

        <div
          class="flex flex-col-reverse xl:flex-row justify-between items-center space-y-4 xl:space-y-0 p-4 sm:p-0 h-full lg:h-[98px]">

          <div class="flex-none w-full xl:w-1/2 flex justify-center lg:justify-start mt-3 xl:mt-0 space-x-4">
            @if ((eventType() === homepageOnlineLiveEvent || eventType() === homepageOnlineOnly) && !isTicketFocused())
            {
            <div class="text-center">
              <button pButton class="flex flex-col md:flex-row relative h-9 
              !text-[var(--p-text-color-secondary)]
              !bg-[var(--p-info-500)] !border-[var(--p-info-500)] 
              hover:!bg-[var(--p-info-600)] hover:!border-[var(--p-info-600)] 
              active:!bg-[var(--p-info-700)] active:!border-[var(--p-info-700)] 
              " [routerLink]="['/item-list', id]">
                <fa-icon [icon]="icons.faShoppingBag" class="text-[16px]"></fa-icon>
                <span class="text-[16px] hidden lg:block">Items</span>
              </button>
              <span class="text-[14px] block lg:hidden">Items</span>
            </div>
            }

            @if (homePageData()?.donateNowEnabled && !isClosed()) {
            <div class="text-center">
              @if (auctionConfigSignal()?.isUsingCustomDonationLink) {
              <a [href]="homePageData()?.customDonationLink">
                <button pButton class="flex flex-col md:flex-row relative h-9 
                !text-[var(--p-text-color-secondary)]
                !bg-[var(--p-info-500)] !border-[var(--p-info-500)] 
              hover:!bg-[var(--p-info-600)] hover:!border-[var(--p-info-600)] 
              active:!bg-[var(--p-info-700)] active:!border-[var(--p-info-700)]">
                  <fa-icon [icon]="icons.faCreditCard" class="text-[16px]"></fa-icon>
                  <span class="text-[16px] hidden lg:block">Donate Now</span>
                </button>
              </a>
              } @else {
              <button pButton class="flex flex-col md:flex-row relative h-9 
              !text-[var(--p-text-color-secondary)]
              !bg-[var(--p-info-500)] !border-[var(--p-info-500)] 
              hover:!bg-[var(--p-info-600)] hover:!border-[var(--p-info-600)] 
              active:!bg-[var(--p-info-700)] active:!border-[var(--p-info-700)]" [routerLink]="['/donation', id]">
                <fa-icon [icon]="icons.faCreditCard" class="text-[16px]"></fa-icon>
                <span class="text-[16px] hidden lg:block">Donate Now</span>
              </button>
              }
              <span class="text-[14px] block lg:hidden">Donate Now</span>
            </div>
            }


            @if (((eventType() === homepageOnlineLiveEvent || eventType() === homepageOnlineOnly) && !isTicketFocused())
            &&
            homePageData()?.itemDonationsEnabled){
            <div class="text-center">
              <button pButton class="flex flex-col md:flex-row relative h-9 
              !text-[var(--p-text-color-secondary)]
              !bg-[var(--p-info-500)] !border-[var(--p-info-500)] 
              hover:!bg-[var(--p-info-600)] hover:!border-[var(--p-info-600)] 
              active:!bg-[var(--p-info-700)] active:!border-[var(--p-info-700)]" [routerLink]="['/items-donation', id]">
                <fa-icon [icon]="icons.faShoppingBag" class="text-[16px]"></fa-icon>
                <span class="text-[16px] hidden lg:block">Donate an Item</span>
              </button>
              <span class="text-[14px] block lg:hidden">Donate an Item</span>
            </div>
            }

            @if (eventType() === homepageOnlineLiveEvent || eventType() === homepageTicketOnly) {
            @if (auctionConfigSignal()?.ticketSalesMode === 'URL') {
            <div class="text-center">
              <a [href]="customTicketSaleLink()">
                <button pButton class="flex flex-col md:flex-row relative h-9 
                !text-[var(--p-text-color-secondary)]
                !bg-[var(--p-info-500)] !border-[var(--p-info-500)] 
              hover:!bg-[var(--p-info-600)] hover:!border-[var(--p-info-600)] 
              active:!bg-[var(--p-info-700)] active:!border-[var(--p-info-700)]">
                  <fa-icon [icon]="icons.faCreditCard" class="text-[16px]"></fa-icon>
                  <span class="text-[16px] hidden lg:block">Tickets</span>
                </button>
              </a>
              <span class="text-[14px] block lg:hidden">Tickets</span>
            </div>
            } @else if (auctionConfigSignal()?.ticketSalesMode === 'FS_TICKETS') {
            <div class="text-center">
              <button pButton class="flex flex-col md:flex-row relative h-9
              !text-[var(--p-text-color-secondary)]
              !bg-[var(--p-info-500)] !border-[var(--p-info-500)]
              hover:!bg-[var(--p-info-600)] hover:!border-[var(--p-info-600)]
              active:!bg-[var(--p-info-700)] active:!border-[var(--p-info-700)]" [routerLink]="['/fs-tickets', id]">
                <fa-icon [icon]="icons.faTicket" class="text-[16px]"></fa-icon>
                <span class="text-[16px] hidden lg:block">Tickets</span>
              </button>
              <span class="text-[14px] block lg:hidden">Tickets</span>
            </div>
            } @else {
            @if (homePageData()?.hasTickets) {
            <div class="text-center">
              <button pButton class="flex flex-col md:flex-row relative h-9 
              !text-[var(--p-text-color-secondary)]
              !bg-[var(--p-info-500)] !border-[var(--p-info-500)] 
              hover:!bg-[var(--p-info-600)] hover:!border-[var(--p-info-600)] 
              active:!bg-[var(--p-info-700)] active:!border-[var(--p-info-700)]" [routerLink]="['/ticket-event', id]">
                <fa-icon [icon]="icons.faTicket" class="text-[16px]"></fa-icon>
                <span class="text-[16px] hidden lg:block">Tickets</span>
              </button>
              <span class="text-[14px] block lg:hidden">Tickets</span>
            </div>
            }
            }
            }
          </div>


          @if ((eventType() === homepageOnlineLiveEvent || eventType() === homepageOnlineOnly) && !isTicketFocused()) {
          <auctions-items-search-bar [auctionId]="id" [shouldGoToSearch]="true" />
          }
        </div>
      </div>

      <!-- Main article section  -->

      <div #auctionInfo id="auction-info" class="mb-10 mt-8">
        <div class="flex flex-col lg:flex-row justify-between">

          @if (hasMainArticleImage()) {
          <div class="w-full lg:w-[calc(50%-15px)] h-[142px] lg:h-auto bg-no-repeat bg-contain bg-top"
            aria-label="Main Article Image"
            [style.backgroundImage]="'url(' + homePageData()?.callToActionImageUrl + ')'">
          </div>
          }

          <div
            [class]="(hasMainArticleImage()?'lg:w-[calc(50%-15px)] ':'') + 'bg-white pr-6 flex flex-col justify-center items-center mt-2 lg:mt-0 w-full px-8 py-5'"
            style="box-shadow:0 4px 4px 0 rgba(0, 0, 0, 0.2);">
            <h1 class="text-[24px] font-mulish font-bold text-black" [innerHTML]="safecallToActionTitleHtml()"></h1>
            <div class="text-[18px] font-mulish text-black mt-3" [innerHTML]="safecallToActionTextHtml()"></div>
            @if (shouldDisplayViewAllItemsButton()) {
            <button [routerLink]="['/item-list', id]"
              class="p-button !rounded-2xl w-full h-9 !text-[var(--p-text-color-primary)] mt-5 relative">
              <fa-icon [icon]="icons.faShoppingBag" class="absolute left-3"></fa-icon>
              View All Items
            </button>
            }
          </div>

        </div>
      </div>

      @if(homePageData()?.showFeaturedSponsors)
      {
      @defer (on idle) {
      <app-auction-homepage-first-tier-sponsors [auctionId]="id"></app-auction-homepage-first-tier-sponsors>
      } @placeholder {
      <div class="flex items-center justify-center min-h-[300px]">
        <p-progress-spinner ariaLabel="loading top sponsors" />
      </div>
      }
      }

      <!-- Live Event Details -->
      @if (eventType() === homepageOnlineLiveEvent || eventType() === homepageTicketOnly) {
      @defer (on viewport(auctionInfo)) {
      <app-auction-homepage-live-event [auctionId]="id" [language]="language" [country]="country"
        [customTicketSaleLink]="customTicketSaleLink()">
      </app-auction-homepage-live-event>
      } @placeholder {
      <div>
        <!-- Live Event Details -->
      </div>
      }
      }

      <div #loadSponsorsCue>
        <!-- empty on purpose -->
      </div>
      <!-- Become a Sponsor -->

      @if (showBecomeASponsorSection()) {
      <div class="mt-8" id="become-sponsor">
        <div class="bg-white flex flex-col lg:flex-row items-start p-8"
          style="box-shadow:0 2px 4px 0 rgba(0, 0, 0, 0.2);">
          <div class="lg:flex-grow mb-4">
            <div class="text-[30px]" [innerHTML]="sanitizeHtmlText(homePageData()?.callOutBoxTitle)"></div>
            <div [innerHTML]="sanitizeHtmlText(homePageData()?.callOutBoxText)"></div>
            @if (homePageData()?.featuredSponsors?.becomeASponsorEnabled) {
            <a [routerLink]="['/become-sponsor', id]">
              <button class="p-button !rounded-2xl w-full h-9 !text-[var(--p-text-color-primary)] mt-5 relative">
                <fa-icon [icon]="icons.faHeart" class="absolute left-3"></fa-icon>
                Become a Sponsor
              </button>
            </a>
            }
          </div>
          @if (featuredSponsors().length > 0) {
          <div class="grid grid-cols-2 min-w-[40%]" style="direction: rtl;">
            @for (featuredSponsor of featuredSponsors(); track $index) {
            <div class="mb-4">

              @if(featuredSponsor.sponsorUrl && featuredSponsor.sponsorUrl.trim() !== '')
              {
              <a [href]="getSafeUri(featuredSponsor.sponsorUrl)" class="flex flex-col items-center">
                @if(featuredSponsor.imageUrl && featuredSponsor.imageUrl.trim() !== '')
                {
                <img [src]="getSafeUri(absoluteMediaUriService.getAbsoluteMediaUri(featuredSponsor.imageUrl))"
                  [alt]="featuredSponsor.name + ' Logo'" class="w-[120px] h-[120px] object-contain">

                @if(featuredSponsor.displayName)
                {
                <div class="text-center text-gray-700">{{ featuredSponsor.name }}</div>
                }

                }@else{
                <div class="text-center text-gray-700">{{ featuredSponsor.name }}</div>
                }
              </a>
              }@else{
              @if(featuredSponsor.imageUrl && featuredSponsor.imageUrl.trim() !== '')
              {
              <div class="flex flex-col items-center ">
                <img [src]="getSafeUri(absoluteMediaUriService.getAbsoluteMediaUri(featuredSponsor.imageUrl))"
                  [alt]="featuredSponsor.name + ' Logo'" class="w-[120px] h-[120px] object-contain">

                @if(featuredSponsor.displayName)
                {
                <div class=" mt-3  text-gray-700 text-center">{{ featuredSponsor.name }}</div>
                }
              </div>
              }@else{
              <div class="flex justify-center">
                <div class="mt-3 text-center text-gray-700">{{ featuredSponsor.name }}</div>
              </div>
              }
              }
            </div>
            }
          </div>
          }
        </div>
      </div>
      }

      <!-- Feature items  -->
      @if ((eventType() === homepageOnlineLiveEvent || eventType() === homepageOnlineOnly) && !isTicketFocused()) {
      @defer (on viewport(auctionInfo)) {
      <app-auction-homepage-featured-items [auctionId]="id"></app-auction-homepage-featured-items>
      } @placeholder {
      <div class="flex items-center justify-center min-h-[300px]">
        <p-progress-spinner ariaLabel="loading featured items" />
      </div>
      }
      }



      <!-- Featured tickets  -->

      @if (eventType() === homepageOnlineLiveEvent || eventType() === homepageTicketOnly) {
      <div *ngIf=" homePageData()?.ticketsHeadline || homePageData()?.tickets!.length > 0" class="w-full mt-8">
        <h2 *ngIf=" homePageData()?.ticketsHeadline" class="text-[23px] font-semibold mb-8"
          [innerHTML]="safeTicketHeadlineHtml()">
        </h2>
        <div>
          <app-tickets *ngIf="homePageData()?.tickets?.length! > 0" [tickets]="homePageData()!.tickets"
            [isHomePage]="true" [auctionId]="id"></app-tickets>
        </div>
        @if (auctionConfigSignal()?.ticketSalesMode === 'URL') {
        <div class="flex justify-end mt-3">
          <a [href]="customTicketSaleLink()"
            class="cursor-pointer  bg-transparent border border-[var(--p-info-500)] text-[var(--p-info-500)]font-[16px] font-mulish text-center px-3 py-2 rounded-full mt-3  mr-0 sm:mr-4 lg:mr-14">
            Go to Tickets
          </a>
        </div>
        } @else if (auctionConfigSignal()?.ticketSalesMode === 'FS_TICKETS') {
        <div class="flex justify-end mt-3">
          <a [routerLink]="['/fs-tickets', id]"
            class="cursor-pointer  bg-transparent border border-[var(--p-info-500)] text-[var(--p-info-500)] font-[16px] font-mulish text-center px-3 py-2 rounded-full mt-3  mr-0 sm:mr-4 lg:mr-14">
            Go to Tickets
          </a>
        </div>
        } @else {
        @if (homePageData()?.hasTickets) {
        <div class="flex justify-end mt-3">
          <a [routerLink]="['/ticket-event', id]"
            class="cursor-pointer  bg-transparent border border-[var(--p-info-500)] text-[var(--p-info-500)] font-[16px] font-mulish text-center px-3 py-2 rounded-full mt-3  mr-0 sm:mr-4 lg:mr-14">
            Go to Tickets
          </a>
        </div>
        }
        }
      </div>
      }

      <!-- top items, top bidders and top referrers -->
      <div class="grid grid-cols-1 lg:grid-cols-4 gap-[29px]">
        <div *ngIf="this.homePageData()?.showTopItems" class="col-span-1 lg:col-span-2">
          <app-auction-homepage-top-items [auctionId]="id"></app-auction-homepage-top-items>
        </div>
        <div *ngIf="this.homePageData()?.showTopBidders" class="col-span-1">
          <app-auction-homepage-top-bidders [auctionId]="id"></app-auction-homepage-top-bidders>
        </div>
        <div class="col-span-1">
          <!-- top-referrers -->
        </div>
      </div>

      <!-- sponsors -->
      @defer (on viewport(loadSponsorsCue)) {
      <app-sponsors [auctionId]="id"></app-sponsors>
      } @placeholder {
      <div class="flex items-center justify-center min-h-[300px]">
        <p-progress-spinner ariaLabel="loading sponsors" />
      </div>
      }

    </div>
  </div>
</ng-template>

<div class="mt-8">
  <app-footer></app-footer>
</div>

<ng-template #heroDonateNowButton>
  @if (homePageData()?.donateNowEnabled) {
  @if (auctionConfigSignal()?.isUsingCustomDonationLink) {
  <a [href]="homePageData()?.customDonationLink">
    <button class="p-button !rounded-2xl h-7 md:h-9 px-4 whitespace-nowrap !text-[var(--p-text-color-primary)]">
      Donate Now 
    </button>
  </a>
  } @else {
  <button [routerLink]="['/donation', id]" class="p-button !rounded-2xl h-7 md:h-9 px-4 whitespace-nowrap !text-[var(--p-text-color-primary)]">
    Donate Now
  </button>
  }
  }
</ng-template>
<ng-template #heroItemsButton>
  <button [routerLink]="['/item-list', id]" class="p-button !rounded-2xl w-32 h-7 md:h-9 !text-[var(--p-text-color-primary)]">
    Items
  </button>
</ng-template>
<ng-template #heroTicketsButton>
  @if (auctionConfigSignal()?.ticketSalesMode === 'URL') {
  <a [href]="customTicketSaleLink()">
    <button class="!bg-[var(--p-primary-500)] !border-[var(--p-primary-500)]
              hover:!bg-[var(--p-primary-600)] hover:!border-[var(--p-primary-600)]
              active:!bg-[var(--p-primary-700)] active:!border-[var(--p-primary-700)] rounded-2xl w-32 h-7 md:h-9 !text-[var(--p-text-color-primary)]">
      Tickets
    </button>
  </a>
  } @else if (auctionConfigSignal()?.ticketSalesMode === 'FS_TICKETS') {
  <button [routerLink]="['/fs-tickets', id]" class="!bg-[var(--p-primary-500)] !border-[var(--p-primary-500)]
              hover:!bg-[var(--p-primary-600)] hover:!border-[var(--p-primary-600)]
              active:!bg-[var(--p-primary-700)] active:!border-[var(--p-primary-700)] rounded-2xl w-32 h-7 md:h-9 !text-[var(--p-text-color-primary)]">
    Tickets
  </button>
  } @else {
  @if (homePageData()?.hasTickets) {
  <button [routerLink]="['/ticket-event', id]" class="!bg-[var(--p-primary-500)] !border-[var(--p-primary-500)]
              hover:!bg-[var(--p-primary-600)] hover:!border-[var(--p-primary-600)]
              active:!bg-[var(--p-primary-700)] active:!border-[var(--p-primary-700)] rounded-2xl w-32 h-7 md:h-9 !text-[var(--p-text-color-primary)]">
    Tickets
  </button>
  }
  }
</ng-template>